export const hasTextSelected = () => {
  return !!window.getSelection()?.toString();
};
